import { combineReducers } from 'redux';
import {ACTION} from './constants';
let initialState={
    apiLoaded: false
};

function careerReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_CAREERS_CONTENT :
            return {...state , ...action.data, apiLoaded:true};

        default:
            return state;
    }
}

export default combineReducers({
    careerList: careerReducer,
});
